"use client";

import { useEffect, useState } from "react";


import { usePathname } from 'next/navigation'
import AuthController from '../controller/AuthController';
import AuthStorage from '../storage/AuthStorage';


export const verifyUser = async () => {

  //const [userExists, setUserExists] = useState(false);
  //let userExists = false;

  //useEffect(() => {

    const authController = new AuthController();
    const authStorage = new AuthStorage(window.location.pathname);
    const dataSubDomain = authStorage.getConfigSubdomain();

    const { subdomain, idSuscripcion, idEmpresa, idioma } = dataSubDomain;
    const userDetails = authStorage.GetCurrentUser();



    let newPath = usePathname;
    newPath = "home";

    let folderAPP = process.env.NEXT_PUBLIC_FOLDER_APP + "/";
    //console.log("folderAPP, ", folderAPP);


    if (userDetails.userName === "") {
      newPath = folderAPP;
    }

    if (userDetails.userName !== undefined && userDetails.userName !== "" && window.location.pathname === folderAPP) {
      console.log("userDetails.userName existe");
      window.location.pathname = newPath;
      console.log("Nuevo,", newPath)
      //newPath = "home";
      //console.log("path configurado", newPath, userDetails);  
      //return (<div>Procesando</div>)
    }
    else if (userDetails.userName === "" && window.location.pathname !== folderAPP) {

      //console.log("hola");
      window.location.href = folderAPP;
    }



  //}, []);


  //return userExists;

}

export const verifySubdomainBase = async () => {

  console.log("verifySubdomainBase, ");

  //const [domainConfigured, setDomainConfigured] = useState(false);
  //console.log("verifySubdomainBase");
  //let domainConfigured = false;

  //useEffect(() => {

  const authController = new AuthController();
  const authStorage = new AuthStorage(window.location.pathname);


  const dataSubDomain = authStorage.getConfigSubdomain();
  const { subdomain, idSuscripcion, idEmpresa, idioma, title, urlLogoLogin, urlLogoFavicon, urlLogoMenu } = dataSubDomain;


  const host = window.location.host; // gets the full domain of the app
  let subdomaintmp = "";

  const arr = host.split(".").slice(0, host.includes("localhost") ? -1 : -2);
  if (arr.length > 0) subdomaintmp = arr[0];
  //if ( (subdomain==undefined || idSuscripcion==undefined)  && subdomaintmp!=""){

  if (subdomaintmp === "") {
    window.location.href = "https:ticsoft.co";
  }

  else if (subdomain === undefined || idSuscripcion === undefined || subdomain === "" || idSuscripcion === "" || idEmpresa === "" || idioma === ""
    || title === "" || urlLogoLogin === "" || urlLogoFavicon === "" || urlLogoMenu === ""
    || subdomaintmp !== subdomain) {
    await configSubdomainBase(subdomaintmp);
  }
  else {

    let urlWebApi = process.env.NEXT_PUBLIC_URL_API;
    document.title = title;

    const link = document.querySelector('link[rel="icon"]');
    if (link !== null)
      link.setAttribute('href', urlWebApi + urlLogoFavicon);

    //setDomainConfigured(true);

  }
  //}, []);


}

export const configSubdomainBase = async (subdomain) => {

  console.log("window, ", window);
  //useEffect( () => {
  console.log("configSubdomainBase2323;");
  const authController = new AuthController();
  const authStorage = new AuthStorage(window.location.pathname);

  let dom = await authController.configSubdomain(subdomain);

  console.log("dom, ", typeof dom, dom);
  let newUrl = window.location.href;

  const dataSubDomain = authStorage.getConfigSubdomain();
  const { idSuscripcion, title, urlLogoLogin, urlLogoFavicon, urlLogoMenu } = dataSubDomain;


  if (dom === undefined) {
    console.log("redireccionar");
    newUrl = "https://www.ticsoft.co/about"
    window.location.href = newUrl; return;
  }
  else if (idSuscripcion> 0) {
    console.log("dominio ok ");
    window.location.href = newUrl; return; //process.env.NEXT_PUBLIC_FOLDER_APP + "/"; return;
  }

  //}, []);

}